import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}/payment-links`
const testUrl = localStorage.getItem(TEST_URl)
const testBaseUrl = `${testUrl}/payment-links`

const baseUrl = testUrl ? testBaseUrl : defaultBaseUrl
export async function createPaymentLinkService (payload) {
  const res = await axios.post(`${baseUrl}`, { ...payload })
  return res
}
export async function updatePaymentLinkService (payload, id) {
  const res = await axios.patch(`${baseUrl}/${id}`, { ...payload })
  return res
}
export async function getPaymentLinksService (payload) {
  const res = await axios.get(
    `${baseUrl}?page=${payload.page}&size=${payload.size}&from=${payload.from}&to=${payload.to}&type=${payload.type}&status=${payload.status}&sort_direction_desc=${payload.sort_direction_desc}&sort_by=${payload.sort_by}`
  )
  return res
}
export async function getPaymentLinkDetailsService (payload) {
  const res = await axios.get(`${baseUrl}/${payload}`)
  return res
}
export async function togglePaymentLinkService (id) {
  const res = await axios.post(`${baseUrl}/toggle-status/${id}`)
  return res
}
export async function getPaymentLinkActivitiesService (payload) {
  const res = await axios.get(
    `${baseUrl}/${payload.paymentLinkId}/activities?page=${payload.page}&size=${payload.size}`
  )
  return res
}
export async function getPaymentLinkTransactionsService (payload) {
  const res = await axios.get(
    `${baseUrl}/${payload.paymentLinkId}/transactions?page=${payload.page}&size=${payload.size}`
  )
  return res
}
